import {Component, OnInit} from '@angular/core';
import {DealerTypeService} from '../../../Services/dealer-type.service';
import {DealerType} from '../../../Models/DealerType';
import {Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-manage-dealer-points',
  templateUrl: './manage-dealer-points.component.html',
  styleUrls: ['./manage-dealer-points.component.scss']
})
export class ManageDealerPointsComponent implements OnInit {
  public dealerTypes: DealerType[] = [];

  constructor(private dealerTypeService: DealerTypeService, private router: Router, private helper: Helper, private translator: TranslateService) {
  }

  ngOnInit() {
    this.dealerTypeService.getDealerTypes().subscribe(res => {
      this.dealerTypes = [];
      if (res.types && res.types.length > 0) {
        res.types.forEach(type => {
          this.dealerTypes.push(type);
        });
      }
    });
  }

  backToDashboard() {
    this.router.navigateByUrl('/back-office/dashboard');
  }

  saveDealerTypes() {
    this.dealerTypeService.manageDealerTypes(this.dealerTypes).subscribe(res => {
      if (res) {
        this.helper.popMessageDialog(
          this.translator.instant('global.success_message.title'),
          this.translator.instant('doctrine.dealer.multipliers_updated'),
          'success',
          false
        );
      }
    });
  }

}
